/**
 * 获取对象的类型字符串
 * @param obj - 待检查的对象
 * @returns 返回对象的类型字符串，如："[object Object]"
 */
export function getType(obj: unknown): string {
  return Object.prototype.toString.call(obj);
}

/**
 *  检查输入是否为函数
 * @param obj - 待检查的对象
 * @returns  如果输入是函数则返回true，否则返回false
 */
export function isFunction(obj: unknown): boolean {
  return getType(obj) === '[object Function]';
}

/**
 * 检查输入是否为字符串
 * @param data - 待检查的数据
 * @returns 如果输入是字符串则返回true，否则返回false
 */
export function isString(data: unknown): boolean {
  return typeof data === 'string';
}

/**
 * 检查输入是否为数组
 * @param data - 待检查的数据
 * @returns 如果输入是数组则返回true，否则返回false
 */
export function isArray(data: unknown): boolean {
  return Array.isArray(data);
}

/**
 * 检查输入是否为对象（非数组、非null）
 * @param data - 待检查的数据
 * @returns 如果输入是纯对象则返回true，否则返回false
 */
export function isObject(data: unknown): boolean {
  return getType(data) === '[object Object]';
}

/**
 * 检查输入是否为undefined
 * @param data - 待检查的数据
 * @returns 如果输入是undefined则返回true，否则返回false
 */
export function isUndefined(data: unknown): boolean {
  return typeof data === 'undefined';
}
